import apiClient from '../apiClient';
import { trackPromise } from 'react-promise-tracker';
import { offlineGet } from '../helpers/offlineHelpers';

// ==========================
// GETS
// ==========================

async function listCorrectionTypes() {
    // const { data } = await trackPromise(apiClient.get('/api/correctionType/getAll'));
    // return data?.data ?? [];

    return offlineGet(
        'correction-types_enabled',
        () => trackPromise(apiClient.get('/api/correctionType/getAll')),
        (response) => response?.data?.data ?? []
    );
}

async function getCorrectionTypeById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/correctionType/getById/${id}`));
    return data?.data ?? null;
}

// ==========================
// MUTATIONS
// ==========================

async function createCorrectionType(payload) {
    const { data } = await trackPromise(apiClient.post('/api/correctionType/add/', payload));
    return data;
}

async function updateCorrectionType(id, payload) {
    const { data } = await trackPromise(apiClient.put(`/api/correctionType/updateById/${id}`, payload));
    return data;
}

async function toggleCorrectionType(id) {
    const { data } = await trackPromise(apiClient.put(`/api/correctionType/enabledDisable/${id}`));
    return data;
}

async function listEnabled() {
    const all = await listCorrectionTypes();
    return all.filter((item) => item.enabled === true);
}

// ==========================
// EXPORT
// ==========================

const correctionTypeService = {
    listCorrectionTypes,
    getCorrectionTypeById,
    createCorrectionType,
    updateCorrectionType,
    toggleCorrectionType,
    listEnabled
};

export default correctionTypeService;
